import { Button, Checkbox, Flex, Select, Stack } from '@mantine/core'
import { modals } from '@mantine/modals'
import React from 'react'

import useUpdateMembership from '../hook/useUpdateMembership.hook'

interface MembershipModalProps {
  membershipId: string
  roleId: string
}

const MembershipModalContent = ({
  membershipId,
  roleId,
}: MembershipModalProps) => {
  const { form, onSubmit, isLoadingUpdate, membershipRoleList } =
    useUpdateMembership(membershipId)

  const actualValueRole =
    membershipRoleList.find((role) => role.label === form.getValues().role)
      ?.value ?? roleId

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault()
        onSubmit()
      }}
    >
      <Stack gap="xl">
        <Select
          key={form.key('role')}
          label="Role"
          withAsterisk
          placeholder="Select Role"
          data={membershipRoleList}
          allowDeselect={false}
          onChange={(_value, option) =>
            form.setFieldValue('role', option.label)
          }
          value={actualValueRole}
        />
        <Checkbox
          key={form.key('status')}
          label="Active"
          defaultChecked
          onChange={(e) =>
            form.setFieldValue(
              'status',
              e.currentTarget.checked ? 'active' : 'inactive',
            )
          }
        />
      </Stack>
      <Flex justify="space-between" align="flex-start" mt="lg">
        <Button onClick={() => modals.closeAll()} variant="outline">
          Cancel
        </Button>
        <Button loading={isLoadingUpdate} onClick={onSubmit} variant="filled">
          Save
        </Button>
      </Flex>
    </form>
  )
}

export const openMembershipModal = (membershipId: string, roleId: string) => {
  return modals.open({
    title: 'Update membership',
    centered: true,
    size: 'md',
    withCloseButton: true,
    children: (
      <MembershipModalContent membershipId={membershipId} roleId={roleId} />
    ),
  })
}
